import { useBlocker } from "react-router-dom";
import { useCallback, useEffect } from "react";
import AppConfig from "util/AppConfig";
const locationHasChanged = (currentLocation, newLocation, question, ignoredRoutes) => newLocation.pathname !== currentLocation.pathname && !ignoredRoutes.includes(newLocation.pathname) ? (
  // eslint-disable-next-line no-alert
  !window.confirm(question)
) : false;
const ConfirmLeaveDialog = ({ question = "Are you sure?", ignoredRoutes = [] }) => {
  const handleLeavePage = useCallback(
    (e) => {
      if (AppConfig.gl2DevMode()) {
        return null;
      }
      e.returnValue = question;
      return question;
    },
    [question]
  );
  useEffect(() => {
    window.addEventListener("beforeunload", handleLeavePage);
    return () => {
      window.removeEventListener("beforeunload", handleLeavePage);
    };
  }, [handleLeavePage]);
  useBlocker(
    (history) => !AppConfig.gl2DevMode() && locationHasChanged(history.currentLocation, history.nextLocation, question, ignoredRoutes)
  );
  return null;
};
export default ConfirmLeaveDialog;
